import i18n from "@/i18n";
import { Dictionary } from "./types";

class PhoneFormat {
  public Country: string = "";
  public Caption: string = "";
  public Zone: string = "";
  public DisplayCode: string = "";
  public Mask: string = "";
  public СheckRegExp: string = "";
  public Placeholder: string = "";
  public Image: string = "";
  public ValidationRules: any[] = [];
}

class OperationPhoneFormats {
  public Field: string = "";
  public Formats: string[] = [];
}

/**  Данные манифеста API. */
class PhoneFormatDir {

  public FormatDict: Dictionary<PhoneFormat> = {};

  public Operations: Dictionary<OperationPhoneFormats> = {};

  constructor(src: any = null) {
    if (src) {
      Object.assign(this, src);

      for (const key of Object.keys(this.FormatDict)) {
        this.FormatDict[key].Mask = this.FormatDict[key].Mask.replace(/[9]/g, "#");
        this.FormatDict[key].ValidationRules = [];
        this.FormatDict[key].ValidationRules.push((p: any) => !!p || i18n.t("auth.errors.phoneEmpty"));

        if (!!this.FormatDict[key].СheckRegExp) {
          this.FormatDict[key].ValidationRules.push((p: any) => {
            return p && new RegExp(this.FormatDict[key].СheckRegExp).test(p) ||
              i18n.t("auth.errors.phoneCheck");
          }
          )
        }
      }
    }
  }
}

export { PhoneFormatDir, OperationPhoneFormats, PhoneFormat }
